
import React, { Dispatch, SetStateAction } from 'react';


const Modal = ({ promptText, date, index, handleDelete, onCancel }: { promptText: string, date: string, index: number, handleDelete: Function, onCancel: any }) => {
  const handleConfirm = () => {
    handleDelete(date, index);
  };

  return (
    <div>
      <div className="modal fade" id="staticBackdrop" aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content bg-white">
            <div className="modal-body pt-4 pb-3 text-center main-msg">
              <p className='mb-0'>{promptText}</p>
            </div>
            <div className="modal-footer justify-content-center border-top-0 pb-4">
              <button type="button" className="grey-outline-btn mr-3" data-bs-dismiss="modal" onClick={onCancel}>Cancel</button>
              <button type="button" className="outline-icon-btn" data-bs-dismiss="modal" onClick={handleConfirm}>Delete</button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
          <p className="modal-title fs-5" id="staticBackdropLabel">
                <span>You'll no longer see this chat here. This will also delete related activity like prompts, responses and feedback from your RON activity.</span>
          </p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" className="btn btn-primary">Cancel</button>
          </div>
        </div>
      </div>
      </div> */}
    </div>

  );
};

export default Modal;
